<!--实时需量 demandRTCurve-->
<template>
  <div class="mydemandRTCurve">
    <div class="con">
      <div class="tree-left">
        <elUnitTree :dataList='getDemanList'></elUnitTree>
      </div>
      <div class="right-table" id="region-cost">
        <div class="Files-top">
          <div class="ic-left">
          </div>
          <div class="btns">
            <el-button @click="getSearch" type="primary" plain class="search-btn">查询</el-button>
            <el-button @click="downloadExcel" type="primary" class="search-btn last-el-button">导出</el-button>
          </div>
        </div>
        <div class="mychart" :style="{'height':heights+'px'}">
          <vchart style="width: 100%;height: 100%;" ref='vchart'></vchart>
        </div>
        <el-table :data="nowPage" :height="tabheights" border style="width: 100%;margin-top:20px">
          <el-table-column label="序号" width="60" align="center">
            <template slot="empty">
              <span class="noData">
                <img src="@/assets/noData.png" alt="暂无数据">
                <span class="text">暂无数据</span>
              </span>
            </template>
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="devicename" label="设备名称" min-width="180"> </el-table-column>
          <el-table-column prop="variableName" label="变量名称" min-width="180"> </el-table-column>
          <el-table-column prop="value" label="实时值" min-width="90" align="right"> </el-table-column>

        </el-table>
        <downloadTable ref="downloadTable"></downloadTable>
      </div>
    </div>
  </div>
</template>
<script>
  import vchart from '@/components/module/chart/vchart.vue'
  import infoList from '@/components/module/universal/infoList.vue'
  import elUnitTree from '@/components/module/newTree/elUnitTree.vue'
  import downloadTable from '@/components/module/downloadTable/downloadTable.vue'
  export default {
    components: {
      vchart,
      infoList,
      elUnitTree,
      downloadTable
    },
    props: {},
    data () {
      return {
        options: {
          "title": {
            "text": "",
            "left": "left",
            "textStyle": {
              "fontSize": 16,
              "fontWeight": "normal",
              "color": "#1a1a1a"
            }
          },
          "toolbox": {
            "show": true,
            "showTitle": true,
            "top": "-5",
            "right": "5",
            "feature": {
              "magicType": {
                "type": ["line","bar","stack","tiled"],
                "title": {
                  "line": "切换为折线图",
                  "bar": "切换为柱状图",
                  "stack": "切换为堆叠",
                  "tiled": "切换为平铺"
                }
              },
              "saveAsImage": {
                "show": true,
                "title": "下载图片"
              }
            }
          },
          "tooltip": {
            "trigger": "axis",
            "confine": true,
            "axisPointer": {
              "animation": true
            }
          },
          "xAxis": {
            "type": "time",
            "splitLine": {
              "show": true
            }
          },
          "yAxis": {
            "type": "value",
            "boundaryGap": [0,"100%"],
            "splitLine": {
              "show": false
            }
          },
          "dataZoom": [{
            "type": "slider",
            "show": true,
            "start": 0,
            "end": 100,
            "handleSize": 8
          },{
            "type": "inside",
            "start": 0,
            "end": 100
          }],
          "grid": {
            "left": "5%",
            "right": "2%",
            "bottom": "50",
            "containLabel": true
          },
          "legend": {
            "data": [],
            "type": "scroll",
            "bottom": "20px",
            "tooltip": {
              "show": true
            },
            "selected": {}
          },
          "series": [{
            "data": [],
            "type": "line",
            "smooth": true
          }]
        },
        nowPage: [{devicename: '永兴旺',variableName: '(当前)正向有功总最大需量',value: '28.00'}],
        heights: Math.round((document.getElementById('app').clientHeight)*0.52),
        tabheights: Math.round((document.getElementById('app').clientHeight)*0.28),
        nowIndex: 0,
        nowDeviceList: [],
        variableTreeResult: {},
        nowSeries: [],
        refreshInterval: 2000,
        columns: [{
          name: '设备名称',
          key: 'devicename'
        },{
          name: '变量名称',
          key: 'variableName'
        },{
          name: '实时值',
          key: 'value'
        }],
        from2name: {},
        demandTree: [],
        demandApptypeList: [264,265,266,267,268,269,270,271,272,273,274,275],
        copynowDeviceList: [],
        mynum: 1
      }
    },
    created () {
    },
    mounted () {
      var dataList=[]
      var now=new Date().getTime()
      for(var i=0;i<90;i++) {
        dataList.unshift([now-this.refreshInterval*i,Math.round(Math.random()*20)])
      }
      this.options.series[0].data=dataList;
      this.$refs.vchart.setData(this.options,true)


    },
    destroyed () {
      removeTask('refreshDemandRTCurve')
      this.realTimeValueStore.commit("removeKeys",this.nowVariableNameList)
    },
    computed: {
      getDemanList () {
        var data=this.$store.deviceStore.getters.getReadDeviceTree

        return isempty(data)? []:[deviceList(data)]
      },
      getBackgroudImageStyle () {
        return this.$store.resourcesStore.getters.getBackgroudImageStyle
      },
      getResourcesByName () {
        return this.$store.resourcesStore.getters.getResourcesByName
      },
      getColorById () {
        return this.$store.resourcesStore.getters.getColorById
      },
      realTimeValueStore () {
        return this.$store.realTimeValueStore
      },
      nowUnit () {
        return this.$store.unitStore.getters.getNowUnit
      },
      nowVariableTree () {
        if(isempty(this.nowDeviceList)) {
          return []
        }
        var variableTreeArr=[]
        this.nowDeviceList.forEach(item => {
          var variableTree=this.$store.variableStore.getters.getVariableTree(item.no)
          variableTree.forEach(tree => {
            tree.devicename=item.name
          })
          variableTreeArr.push(variableTree)
        })
        var result=[]
        variableTreeArr.forEach(item => {
          result=result.concat(item)
        })
        return result
      },
      nowVariableList () {
        if(isempty(this.nowDeviceList)) {
          return []
        }
        // 当前要显示的变量列表
        var variableList=[]
        for(var i=0,len=this.nowVariableTree.length;i<len;i++) {
          var item=this.nowVariableTree[i]
          for(var i1=0,len1=item.next.length;i1<len1;i1++) {
            var item1=item.next[i1]
            item1.devicename=item.devicename
            if(this.demandApptypeList.includes(item1.typeNo)) {
              var newItem=copy(item1)
              newItem.name=newItem.name.subByFirstChar(".")
              variableList.push(newItem)
            }
          }
        }
        variableList.sort((a,b) => {
          return a.typeNo-b.typeNo
        })
        return variableList
      },
      nowVariableNameList () {
        this.from2name={}
        return this.nowVariableList.map(item => {
          this.$set(this.from2name,item.fromName,item.name)
          return item.fromName
        })
      },
      pageLen () {
        return this.dataList.length<20? this.dataList.length:20
      },

      dataList () {
        if(isempty(this.nowVariableNameList)) {
          return []
        }
        //获取实时值
        var vl=this.realTimeValueStore.getters.getValue(this.nowVariableNameList)
        var nameList=[]
        return this.nowVariableNameList.map((item,index) => {
          var value=vl[index]
          if(isNaN(parseFloat((value)))||isnull(parseFloat((value)))) {
            value="--"
          }
          var name=this.from2name[item]? this.from2name[item]:item

          var indexLabel=0
          nameList.forEach(i => {
            if(i==name) {
              indexLabel++
            }
          })
          nameList.push(name)
          if(indexLabel>0) {
            name=name+indexLabel
          }
          return {
            devicename: this.nowVariableList[index].fromName.split('.')[0],
            variableName: name,
            value
          }
        })
      },
    },
    watch: {
      nowVariableNameList (nv,ov) {
        this.realTimeValueStore.commit("removeKeys",ov)
        this.realTimeValueStore.commit("addKeys",nv)
        //重置缓存数据
        var list=[]
        var dataList=[]
        var now=new Date().getTime()
        for(var i=0;i<90;i++) {
          dataList.unshift([now-this.refreshInterval*i,12])
        }
        var valueList=dataList.map(item => {
          return item[1]
        })
        var sumData={}
        nv.forEach((item,index) => {
          var devicename=this.nowVariableList[index].fromName
          var typeName=this.from2name[item]? this.from2name[item]:item
          var name=devicename /*+ "_" + typeName*/
          list.push({
            name,
            type: 'line',
            smooth: true,
            symbol: 'emptyCircle',
            sampling: 'average',
            markPoint: {
              data: [{
                name: '最大值',
                type: 'max'
              }]
            },
            data: dataList.copy()
          })
        })
        this.nowSeries=list
        this.options.series=list
        var selected={}
        this.options.legend.data=
          nv.map((item,index) => {
            var devicename=this.nowVariableList[index].fromName
            var typeName=this.from2name[item]? this.from2name[item]:item
            var name=devicename+"_"+typeName
            if(index>5) {
              selected[name]=false
            }
            return {
              name: name,
              icon: 'roundRect'
            }
          })
        this.options.legend.selected=selected
      },
      nowUnit (nv,ov) {
        this.loadDemandTree()
      },
      copynowDeviceList (val) {
        this.mynum+=1
        if(this.mynum==2) {
          this.nowDeviceList=val
        }
      }
    },
    methods: {
      downloadExcel () {
        // this.$refs.infoList.downloadExcel('实时需量');
        let time=new Date();
        let year=time.getFullYear();
        let month=time.getMonth()+1;
        let day=time.getDate();
        let hous=time.getHours();
        let fens=time.getMinutes();
        let miaos=time.getSeconds();
        const tHeader=[year+"-"+month+"-"+day+'  '+hous+":"+fens+":"+miaos+'-实时需量'];
      },
      treeCheckItem (item) {
        // this.nowDeviceList=item
        this.copynowDeviceList=item
        // item.forEach(list=>{
        // 	if(list.type=='virtualDevice'){
        // 		this.nowDeviceList.push(list)
        // 	}
        // })
      },
      getSearch () {
        this.nowDeviceList=this.copynowDeviceList
      },
      loadDemandTree () {
        //查询需量设备树
        /*	this.$api.deviceApi.getReadDeviceTree(this.nowUnit.unitId, "264,265,266", respon => {
            var tree = findTreeItem([respon], item => {
            return item.unitid == this.nowUnit.id
          })
            this.demandTree = [deviceList(tree)]
          	
        	
          })*/
      },
      addData () {
        //增加新值
        if(isempty(this.nowVariableNameList)) {
          return
        }
        if(this.$refs.vchart==undefined) {
          return
        }
        var vl=this.realTimeValueStore.getters.getValue(this.nowVariableNameList)
        var now=Date.now()
        this.nowSeries.forEach((item,index) => {
          item.data.shift()
          var res=vl[index]
          if(isNaN(parseFloat((res)))||isnull(parseFloat((res)))) {
            res=undefined
          }
          item.data.push([now,res])
        })

      }
    }
  }
</script>

<style scoped lang="scss">
  .mydemandRTCurve {
    .con {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      display: flex;

      .Files-top {
        border: 0px !important;
      }

      .public-flex {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      // 正常
      .patrol {
        p {
          width: 8px;
          height: 8px;
          background-color: #0DAE88;
          border-radius: 50%;
          margin-right: 8px;
        }

        span {
          color: #0DAE88;
        }
      }

      // 非正常
      .rush {
        p {
          width: 8px;
          height: 8px;
          background-color: #FF1D1D;
          border-radius: 50%;
          margin-right: 8px;
        }

        span {
          color: #FF1D1D;
        }
      }

      .paging {
        display: flex;
        justify-content: flex-end;
        margin-top: 15px;
      }

      .tree-left {
        width: 3rem;
        height: 100%;
        padding: 12px;
        box-sizing: border-box;
        background-color: #fff;
        margin-right: 8px;

        .btns {
          display: flex;
          // justify-content: space-evenly;
          margin-bottom: 8px;

          button {
            margin-right: 12px;
          }

          .el-button--mini {
            padding: 7px 10px !important;
          }

          .el-button+.el-button {
            margin-left: 0px;
          }
        }

        .search {
          display: flex;
          justify-content: center;
          margin-bottom: 12px;
        }

      }

      .right-table {
        width: calc(100% - 3.08rem);
        height: 100%;
        padding: 12px 20px 20px 20px;
        box-sizing: border-box;
        background-color: #fff;
        position: relative;

        .mycharts {
          display: flex;

          .charts-left {
            width: 35%;
          }

          .charts-right {
            width: 70%;
          }
        }
      }
    }
  }
</style>